export default (node) => node && node.tagName && node.tagName.toLowerCase() === 'img';
